import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../localization/strings"
import Dropzone from "react-dropzone"
import { grey200 } from "material-ui/styles/colors"
import * as utils from "../../helpers/utils"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {
    handleSave(files: any[]): void
    handleClose(): void
}
interface IState {
    files: any[]
}

export default class AddPicDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            files: [],
        }
        autobind(this)
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Add_Photo}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton
                        data-intercom-target={"menu-Add-Pic-Btn-CloseDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"menu-Add-Pic-Btn-SaveAdjustment"}
                        label={strings.SAVE}
                        primary
                        onClick={() => {
                            if (!this.state.files.length) return
                            this.props.handleSave(this.state.files)
                            this.props.handleClose()
                        }}
                    />
                ]}
            >
                <div style={{ paddingTop: 20, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <div>
                        <Dropzone
                            data-intercom-target={"OpenFileUploadSelection"}
                            onDrop={(files: any[]) => {
                                files.find(file => !utils.validateUploadFileExtension(file, false, true)) ?
                                    AppStateStore.setAlertDialogContent({
                                        title: strings.This_file_format_is_not_supported,
                                        content: strings.Supported_file_types + ": .jpg, .jpeg, .png, .bmp"
                                    }) :
                                    files.find(file => !utils.validateFileSize(file)) ?
                                        AppStateStore.setAlertDialogContent({
                                            title: strings.This_file_size_is_too_large,
                                            content: strings.Maximum_File_Size + ": 10 MB"
                                        }) :
                                        this.setState({ files })
                            }}
                            style={{
                                height: 75,
                                width: 375,
                                border: "dashed 1px #cccccc",
                                fontSize: 15,
                                textAlign: "center",
                                backgroundColor: grey200,
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}
                            activeStyle={{
                                border: "dashed 1px #666666",
                                background: "#e7e7e7"
                            }}
                        >
                            <span style={{ whiteSpace: "pre-line" }}>{strings.Drag_and_Drop_or_click_to_choose_a_picture_files}</span>
                        </Dropzone>
                    </div>
                    {this.state.files.length > 0 &&
                        <div style={{ display: "flex", marginTop: 15 }}>
                            {this.state.files.map(file =>
                                <div
                                    key={file.name}
                                    style={{
                                        display: "inline-flex",
                                        borderRadius: 2,
                                        border: "1px solid #eaeaea",
                                        marginBottom: 8,
                                        marginRight: 8,
                                        width: 100,
                                        height: 100,
                                        padding: 4,
                                        boxSizing: "border-box"
                                    }}
                                >
                                    <div style={{ minWidth: 0, overflow: "hidden" }}>
                                        <img
                                            alt="selected"
                                            src={file.preview}
                                            style={{
                                                display: "block",
                                                width: "auto",
                                                height: "100%"
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    }
                </div>
            </Dialog>
        )
    }
}